// extracted by mini-css-extract-plugin
export var aboutText = "about-module--aboutText--Nk0uF";
export var headline = "about-module--headline--CtAVn";
export var selfPortrait = "about-module--selfPortrait--9+Uoc";